import { CrownIcon } from "lucide-react";
import React from "react";
import ProductDetailHeader from "./ProjectDetailHeader";
import AddProjectObjectiveModal from "../modals/AddProjectObjectiveModal";

interface ProjectObjectivesProps {
  objectives: string;
}

const ProjectObjectives: React.FC<ProjectObjectivesProps> = ({
  objectives,
}) => {
  return (
    <div className="grid gap-2">
      <ProductDetailHeader
        icon={<CrownIcon className={`w-5 h-5 mr-2 text-black`} />}
        label="Objectifs du projet"
      />
      <ul className="space-y-2">
        {objectives?.split(",").map((objective, index) => (
          <li
            key={index}
            className="flex items-start space-x-2 bg-slate-100 px-4 py-3 rounded-2xl"
          >
            <div className="bg-rajapiNavyBlue rounded-full w-7 h-7 text-center ">
              <span className="text-white align-middle	">{index + 1}</span>
            </div>
            <p className="text-gray-700">{objective}</p>
          </li>
        ))}
      </ul>
      <AddProjectObjectiveModal />
    </div>
  );
};

export default ProjectObjectives;
